module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_9016.97d03158.png";